import React from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Button } from "react-bootstrap";

const NotFound = () => {
  const navigate = useNavigate();
  const { isAuthenticated, user } = useSelector((state) => state.auth);

  // Send users back somewhere meaningful based on their session.
  const goHome = () => {
    if (isAuthenticated) {
      navigate(user && user.type === "admin" ? "/admin/spots" : "/user/spots");
    } else {
      navigate("/");
    }
  };

  return (
    <div className="notfound-page">
      <div className="notfound-card">
        <div className="notfound-visual">
          <span className="notfound-code">404</span>
          <span className="notfound-pin">
            <i className="fas fa-map-marker-alt" />
          </span>
        </div>

        <h1 className="notfound-title">Lost your parking spot?</h1>
        <p className="notfound-text">
          The page you're looking for doesn't exist or has been moved.
          Let's get you back on the road.
        </p>

        <div className="notfound-actions">
          <Button variant="" className="btn-pill-primary" onClick={goHome}>
            <span>
              <i className="fas fa-home me-2" />
              Back to home
            </span>
          </Button>
          <Button
            variant=""
            className="btn-pill-outline"
            onClick={() => navigate(-1)}
          >
            <span>
              <i className="fas fa-arrow-left me-2" />
              Go back
            </span>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
